export const NAV_MENU_IDS = {
  SOLUTIONS: '438',
  SERVICES: '454',
  LOCATIONS: '457',
  TIPS_TRICKS: '469',
  HAMBURGER_MENU: '486',
}
